export const versionNumber = 'v2.40.1'
